import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faInstagram, faPinterest, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faLocationDot, faPhone, faEnvelope, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Logo from "../Images/logo 1.png";
import "../Styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      {/* Top CTA Strip */}
      <div className="footer-cta-strip">
        <div className="container footer-cta-inner">
          <div className="footer-cta-text">
            <h4>Ready to secure your family's financial future?</h4>
            <p>Schedule a free, no-obligation consultation today.</p>
          </div>
          <Link to="/schedule-appointment" className="btn-primary">
            Book Consultation <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="container footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <img src={Logo} alt="Ebenezer Family Group" className="footer-logo" />
            <p className="footer-tagline">
              Helping families build lasting financial security through education, 
              personalized strategy, and innovative solutions. Your family's future 
              starts with a conversation.
            </p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/people/Ebenwealth/61578519344274/" target="_blank" rel="noreferrer" aria-label="Facebook"><FontAwesomeIcon icon={faFacebookF} /></a>
              <a href="https://x.com/ebenwealthh" target="_blank" rel="noreferrer" aria-label="Twitter"><FontAwesomeIcon icon={faTwitter} /></a>
              <a href="https://www.instagram.com/ebenwealth7/" target="_blank" rel="noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
              <a href="https://www.pinterest.com/ebenwealth/" target="_blank" rel="noreferrer" aria-label="Pinterest"><FontAwesomeIcon icon={faPinterest} /></a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedinIn} /></a>
            </div>
          </div>

          {/* Navigate */}
          <div className="footer-links-col">
            <h5>Navigate</h5>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/schedule-appointment">Book Consultation</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-links-col">
            <h5>Services</h5>
            <ul>
              <li><Link to="/services">Life Insurance</Link></li>
              <li><Link to="/services">Retirement Planning</Link></li>
              <li><Link to="/services">Financial Education</Link></li>
              <li><Link to="/services">Business Protection</Link></li>
              <li><a href="https://kaizennlg.simplicityniw.com/3f249eec-ddec-4dc0-9ee6-4f8d41425f71" target="_blank" rel="noreferrer">Kai-Zen Plan</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-contact-col">
            <h5>Contact</h5>
            <div className="footer-contact-items">
              <div className="footer-contact-item">
                <FontAwesomeIcon icon={faLocationDot} className="footer-contact-icon" />
                <span>6160 Summit Dr N Suite#145<br/>Brooklyn Center, MN 55429</span>
              </div>
              <div className="footer-contact-item">
                <FontAwesomeIcon icon={faPhone} className="footer-contact-icon" />
                <span>+1 763-271-9700</span>
              </div>
              <div className="footer-contact-item">
                <FontAwesomeIcon icon={faEnvelope} className="footer-contact-icon" />
                <span>financialsolutions@ebenwealth.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© 2025 Ebenezer Family Group. All rights reserved.</p>
          <div className="footer-legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span>|</span>
            <Link to="/terms-of-use">Terms of Use</Link>
          </div>
          <p className="footer-credit">Designed by <a href="https://xendek.com" target="_blank" rel="noreferrer">Xendek</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
